export default __webpack_public_path__ + "static/media/ET.84371b74.ico";